<template>
  <div class="size-settings-wrap">
    <b-form-radio-group
      v-model="element.settings.sizeSettingValue"
      :options="sizeSettingList"
      value-field="value"
      text-field="label"
      :buttons="true"
      :disabled="element.settings.disabled"
      @change="handleSizeChange"
    ></b-form-radio-group>
    <div
      class="custom-size-settings"
      v-if="
        element.settings.sizeSettingValue === 'individuel' &&
        this.element.settings.customSize
      "
    >
      <label class="caption">Dimensionen </label>
      <div
        class="input-group w-100 d-flex align-items-center justify-content-between"
      >
        <div class="input-wrap position-relative">
          <input
            class="width"
            v-model.number="element.settings.customSize.width"
            type="number"
          />
          <p>W</p>
        </div>
        <div class="input-wrap position-relative">
          <input
            class="height"
            v-model.number="element.settings.customSize.height"
            type="number"
          />
          <p>H</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionSizeSettings',
  data() {
    return {
      sizeSettingList: [
        { label: 'Klein', value: 'small' },
        { label: 'Mittle', value: 'medium' },
        { label: 'Groß', value: 'large' },
        { label: 'Individuel', value: 'individuel' },
      ],
    };
  },
  props: {
    element: Object,
    isUserHasAccess: Boolean,
  },
  methods: {
    handleSizeChange(selectValue) {
      if (selectValue === 'individuel' && !this.element.settings.customSize) {
        this.$set(this.element.settings, 'customSize', {
          width: 75,
          height: 75,
        });
      }
    },
  },
};
</script>

<style scoped>
.size-settings-wrap {
  padding: 12px 0;
  padding-left: 20px;
}
.size-settings-wrap ::v-deep .btn-group-toggle {
  display: flex;
  gap: 7px;
  align-items: center;
  justify-content: center;
  flex-flow: row;
}
.size-settings-wrap ::v-deep .btn {
  border-radius: 16px !important;
  height: 30px;
  min-width: 61px;
  border: 0.7px solid #d9dbdc;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-family: 'OpenSans-regular';
  font-size: 14px;
  letter-spacing: -0.02em;
  line-height: 30px;
  color: #000000;
  transition: transform 0.3s ease;
}
.size-settings-wrap ::v-deep .btn:hover {
  border-color: #000000;
  transition: 0.2s ease all;
}
.size-settings-wrap ::v-deep .btn.active {
  background-color: #060606;
  border-color: #060606;
  color: #ffffff;
}

.size-settings-wrap ::v-deep .btn input {
  display: none;
}
.size-settings-wrap .custom-size-settings {
}
.size-settings-wrap .custom-size-settings .input-group input,
.size-settings-wrap .custom-size-settings .input-group p,
.size-settings-wrap .custom-size-settings .caption {
  font-family: 'OpenSans-Regular';
  font-size: 13px;
  font-weight: 400;
  color: #484e5e;
  letter-spacing: -0.02em;
  line-height: 36px;
}
.size-settings-wrap .custom-size-settings .caption {
  padding: 6px 0;
}
.size-settings-wrap .custom-size-settings .input-wrap {
  width: calc(50% - 4px);
}
.size-settings-wrap .custom-size-settings .input-wrap input {
  color: #111111;
  border: 0.7px solid #d9dbdc;
  border-radius: 16px;
  width: 100%;
  padding-left: 34px;
}

.size-settings-wrap
  .custom-size-settings
  input[type='number']::-webkit-inner-spin-button,
.size-settings-wrap
  .custom-size-settings
  input[type='number']::-webkit-outer-spin-button {
  transform: translateX(-10px) scale(0.8);
  padding: 0;
}
.size-settings-wrap .custom-size-settings .input-wrap p {
  padding: 0;
  margin: 0;
  position: absolute;
  color: #484e5e;
  top: -4px;
  left: 11px;
}
</style>
